export const MembershipEndpoints = {
  getMembershipData: (slug: string) =>
    `${process.env.CONTENT_URL}/rest/public/v1/memberships/${slug}`
};
